import { render, staticRenderFns } from "./SaleDeliveryStatus.vue?vue&type=template&id=35749f26&"
import script from "./SaleDeliveryStatus.vue?vue&type=script&lang=js&"
export * from "./SaleDeliveryStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports